export const trendBackground = (theme, trend = "neutral") => ({
  good: theme.colors.variant.success,
  bad: theme.colors.variant.danger,
  neutral: theme.colors.global.contentBackground
})[trend];
export const diff = (current, previous) => {
  if (typeof current === "number" && typeof previous === "number") {
    const difference = current - previous;
    const differencePercent = difference / previous;
    return [difference, differencePercent];
  }
  return [NaN, NaN];
};
const trendDirection = (current, previous, trendPreference) => {
  const [delta] = diff(current, previous != null ? previous : void 0);
  if (!Number.isFinite(delta) || delta === 0) {
    return "neutral";
  }
  switch (trendPreference) {
    case "LOWER":
      return delta > 0 ? "bad" : "good";
    case "HIGHER":
      return delta > 0 ? "good" : "bad";
    case "NEUTRAL":
    default:
      return "neutral";
  }
};
export default trendDirection;
